import Vue from 'vue'
import Router from 'vue-router'
import Top from './views/ja/Top.vue'
import enTop from './views/en/Top.vue'
import TermsOfService from './views/ja/TermsOfService.vue'
import enTermsOfService from './views/en/TermsOfService.vue'
import PrivacyPolicy from './views/ja/PrivacyPolicy.vue'
import enPrivacyPolicy from './views/en/PrivacyPolicy.vue'
import AppText from './views/app/Text.vue'
import Faq from './views/Faq.vue'
import AboutUs from './views/ja/AboutUs.vue'
import enAboutUs from './views/en/AboutUs.vue'

import goTo from 'vuetify/es5/services/goto'

Vue.use(Router)

/**
 * 現在地と同じルートへの push / replace で発生する NavigationDuplicated を無視する。
 * それ以外のナビゲーションエラーは呼び出し元へそのまま伝播させる。
 */
const { isNavigationFailure, NavigationFailureType } = Router;
['push', 'replace'].forEach((method) => {
  const original = Router.prototype[method]
  Router.prototype[method] = function (location, onComplete, onAbort) {
    // コールバック形式で呼ばれた場合は従来どおり
    if (onComplete || onAbort) {
      return original.call(this, location, onComplete, onAbort)
    }
    return original.call(this, location).catch((err) => {
      if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
        return err
      }
      throw err
    })
  }
})

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/en/',
      name: 'enTop',
      component: enTop
    },
    {
      path: '/ja/tos',
      name: 'TermsOfService',
      component: TermsOfService
    },
    {
      path: '/en/tos',
      name: 'enTermsOfService',
      component: enTermsOfService
    },
    {
      path: '/ja/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/en/privacy',
      name: 'enPrivacyPolicy',
      component: enPrivacyPolicy
    },
    {
      path: '/ja/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/en/aboutUs',
      name: 'enAboutUs',
      component: enAboutUs
    },
    {
      path: '/ja/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/app/tos/:lang',
      name: 'AppTos',
      component: AppText,
    },
    {
      path: '/app/privacy/:lang',
      name: 'AppPrivacy',
      component: AppText,
    },
    {
      path: '/:dummy',
      redirect: '/',
    },
  ]
})
